import { render, staticRenderFns } from "./DTable.vue?vue&type=template&id=dd0cfd08&"
import script from "./DTable.vue?vue&type=script&lang=js&"
export * from "./DTable.vue?vue&type=script&lang=js&"
import style0 from "./DTable.vue?vue&type=style&index=0&id=dd0cfd08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports